// Auth utilities for token management

/**
 * Get the stored authentication token
 * @returns {string|null} The stored token or null if not found
 */
export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

/**
 * Store the authentication token
 * @param {string} token - The token to store
 */
export const setToken = (token: string): void => {
  localStorage.setItem('token', token);
  localStorage.setItem('tokenRefreshedAt', Date.now().toString());
};

/**
 * Remove the stored authentication token
 */
export const removeToken = (): void => {
  localStorage.removeItem('token');
  localStorage.removeItem('tokenRefreshedAt');
};

/**
 * Check if the user is authenticated (has a token)
 * @returns {boolean} Whether the user is authenticated
 */
export const isAuthenticated = (): boolean => {
  return !!getToken();
};

/**
 * Store user information
 * @param {object} user - The user object to store
 */
export const setUser = (user: any): void => {
  localStorage.setItem('user', JSON.stringify(user));
};

/**
 * Get stored user information
 * @returns {object|null} The stored user object or null if not found
 */
export const getUser = (): any => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch (error) {
      console.error('Error parsing user data:', error);
      return null;
    }
  }
  return null;
};

/**
 * Remove stored user information
 */
export const removeUser = (): void => {
  localStorage.removeItem('user');
};

/**
 * Logout the user by removing token and user information
 */
export const logout = (): void => {
  removeToken();
  removeUser();
};

export default {
  getToken,
  setToken,
  removeToken,
  isAuthenticated,
  setUser,
  getUser,
  removeUser,
  logout
}; 